import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgRead = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19 14" {...props}>
    <g fill="none" fillRule="evenodd" stroke="#007AFF">
      <path d="m.875 7.393 4.051 3.982L14 2.625" />
      <path d="m5.25 7.393 4.051 3.982 9.074-8.75" />
    </g>
  </svg>
);
const Memo = memo(SvgRead);
export default Memo;
